import React from 'react';
import './LoadingSpinner.css';

function LoadingSpinner() {
    return <div className="spinner"></div>;
}

export default LoadingSpinner;